module.exports = __webpack_public_path__ + "img/al-based.4b05ccf4.webp";